export const phieuNhanHang = {
  sections: {
    list: { title: 'Phiếu nhận hàng' },
    detail: { title: 'Chi tiết phiếu nhận' },
    lines: 'Danh sách nhận hàng',
    soKhops: 'So khớp nhận hàng',
  },
  titles: { add: 'Tạo phiếu nhận', addNew: 'Thêm mới' },
  placeholders: {
    ghiChu: 'Ghi chú (vd: thiếu bao bì, hàng lỗi)',
  },
  form: {
    codeAuto: 'Để trống tự sinh mã',
    trangThai: 'Trạng thái',
    sectionHeader: 'Thông tin phiếu nhận',
    sectionSummary: 'Tổng kết nhận',
    sectionLines: 'Hàng nhận',
    sectionMuaHang: 'Thông tin vận chuyển & mua hàng',
    sectionLogistics: 'Logistics & packing',
    tongSoLuongDat: 'Tổng SL dự kiến',
    tongSoLuongNhan: 'Tổng SL thực tế',
    tongThieu: 'Tổng thiếu',
    tongThua: 'Tổng thừa',
    tongTienHang: 'Tổng tiền hàng',
    tongSoMatHang: 'Số mặt hàng',
    maSp: 'Mã SP',
    tenSp: 'Tên SP',
    lineNote: 'Ghi chú',
    datHangNcc: 'Đơn đặt hàng',
    nhaCungCap: 'Nhà cung cấp',
    note: 'Ghi chú phiếu',
    save: 'Lưu',
    chooseDatHangNcc: 'Chọn đơn đặt hàng',
    openSourcePo: 'Chọn đơn đặt hàng NCC làm nguồn',
    datHangNccClear: 'Bỏ chọn đơn đặt hàng',
    datHangNccSearch: 'Tìm đơn đặt hàng NCC',
    datHangNccEmpty: 'Chưa có đơn đặt hàng nào.',
    productSearch: 'Tìm hàng hóa',
    lotRequired: 'Số lô *',
    startTitle: 'Bắt đầu tạo phiếu nhận',
    startHint: 'Chọn cách tạo — hệ thống sẽ nạp sẵn thông tin phù hợp.',
    pathFromPo: 'Từ đơn đặt hàng',
    pathFromPoHint: 'Nạp sẵn NCC và danh sách hàng theo đơn. Chỉ cần chỉnh SL thực nhận.',
    pathIndependent: 'Nhận độc lập',
    pathIndependentHint: 'Chọn NCC rồi thêm hàng bằng F3 — dùng khi không có đơn đặt.',
    pathRecommended: 'Khuyên dùng',
    backToStart: 'Chọn lại cách tạo',
    receiveAll: 'Nhận đủ',
    receiveAllHint: 'Gán SL thực tế = SL dự kiến cho mọi dòng',
    lineCount: '{count} dòng',
    tuMuaHang: 'Từ mua hàng',
    tuMuaHangHint: 'Phiếu tạo từ hệ thống mua hàng — không sửa được dòng hàng và số lượng',
    emptyNeedSource: 'Chọn nguồn nhận hàng để tiếp tục.',
    emptyPickSupplier: 'Chọn nhà cung cấp ở trên, rồi thêm hàng bằng F3.',
    emptyFromPo: 'Đơn này chưa có dòng hàng.',
    emptyAddProduct: 'Chưa có hàng — tìm và thêm hàng để nhận.',
    emptyF3Hint: 'Nhấn F3 để tìm hàng nhanh.',
  },
  aria: {
    columnPicker: 'Chọn cột hiển thị',
  },
  columns: {
    tongSoLuong: 'Tổng SL',
    tongTienHang: 'Tổng tiền hàng',
    canTraNCC: 'Cần trả NCC',
    code: 'Mã phiếu nhận',
    chiNhanh: 'Chi nhánh',
    summary: 'Thông tin',
    status: 'Trạng thái',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
    maDatHang: 'Mã đặt hàng',
    nhaCungCap: 'Nhà cung cấp',
    ngayNhan: 'Ngày nhận',
    maPhieuNhapKho: 'Phiếu nhập kho',
  },
  filter: {
    searchPlaceholder: 'Theo mã phiếu nhận, mã đặt hàng, tên NCC',
    title: 'Lọc',
    supplier: 'Nhà cung cấp',
    datHangNcc: 'Đơn đặt hàng',
    trangThai: 'Trạng thái',
    chiNhanh: 'Chi nhánh',
    tuNgay: 'Từ ngày',
    denNgay: 'Đến ngày',
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    dateRangePlaceholder: 'Chọn khoảng ngày',
    maVanChuyenAzl: 'Mã vận chuyển AZL',
    maYcmh: 'Mã YCMH',
    sortDir: 'Thứ tự',
    asc: 'Tăng dần',
    desc: 'Giảm dần',
    all: 'Tất cả',
    reset: 'Đặt lại',
    nccTreeAll: 'Tất cả nhà cung cấp',
    nccTreeSearch: 'Tìm nhà cung cấp',
    nccTreeEmpty: 'Không có nhà cung cấp',
    chiNhanhTreeAll: 'Tất cả chi nhánh',
    chiNhanhTreeSearch: 'Tìm chi nhánh',
    chiNhanhTreeEmpty: 'Không có chi nhánh',
  },
  fields: {
    code: 'Mã phiếu nhận',
    chiNhanh: 'Chi nhánh',
    maDatHang: 'Mã đặt hàng',
    supplier: 'Nhà cung cấp',
    ngayNhan: 'Ngày nhận',
    ngayNhapMua: 'Thời gian nhập mua',
    status: 'Trạng thái',
    ghiChu: 'Ghi chú',
    product: 'Hàng hóa',
    productCode: 'Mã hàng',
    productName: 'Tên hàng',
    donViTinh: 'ĐVT',
    tyLeQuyDoi: 'Tỷ lệ quy đổi',
    soLuongDat: 'SL nhận dự kiến',
    soLuongNhan: 'SL nhận thực tế',
    soLuongThieu: 'Thiếu',
    soLuongThua: 'Thừa',
    chenhLech: 'Chênh',
    maLo: 'Số lô',
    hanSuDung: 'Hạn sử dụng',
    donGia: 'Đơn giá',
    thanhTien: 'Thành tiền',
    lineGhiChu: 'Ghi chú dòng',
    actions: 'Thao tác',
    nguoiNhan: 'Người nhận',
    createdAt: 'Ngày tạo',
    // Field tích hợp service mua hàng
    soRef: 'Số REF',
    ngayDatHangThucTe: 'Ngày đặt hàng thực tế',
    ngayPhatHangThucTe: 'Ngày phát hàng thực tế',
    ngayVeKhoThucTe: 'Ngày về kho thực tế',
    tenNhanVienMuaHang: 'NV mua hàng',
    tenNhanVienYeuCau: 'NV yêu cầu',
    tongTheTich: 'Tổng thể tích (m³)',
    tongCanNang: 'Tổng cân nặng (kg)',
    hinhThucVc: 'Hình thức VC',
    cont: 'Cont',
    maVanChuyenNcc: 'Mã vận chuyển NCC',
    maVanChuyenAzl: 'Mã vận chuyển AZL',
    maYcmh: 'Mã YCMH',
    maBaoGia: 'Mã báo giá',
    ngayBaoGia: 'Ngày tạo báo giá',
    donViTinhMua: 'ĐVT mua',
    soLuongKhuyenMai: 'SL/KM',
    tongSoLuongSanPham: 'Tổng SL SP',
    soKien: 'SL kiện',
    daiThung: 'Dài thùng',
    rongThung: 'Rộng thùng',
    caoThung: 'Cao thùng',
    theTichThung: 'M3/thùng',
    canNangThung: 'Kg/thùng',
    quyCachThung: 'Quy cách/thùng',
    canNangSanPham: 'Kg/SP',
    theTichSanPham: 'M3/SP',
  },
  status: {
    choNhan: 'Chờ nhận',
    daNhanXong: 'Đã nhận xong',
    daHuy: 'Đã hủy',
    khac: 'Khác',
  },
  filters: {
    hintSection: 'Bộ lọc phiếu nhận hàng',
    hintBody: 'Lọc theo trạng thái, ngày nhận, nhà cung cấp hoặc đơn đặt hàng.',
  },
  menu: {
    openSupplierList: 'Nhà cung cấp (DS)',
    createfromPhieuNhan: 'Tạo từ phiếu nhận',
  },
  actions: {
    exportFile: 'Xuất file',
    addLine: 'Thêm dòng hàng',
    complete: 'Hoàn thành nhận',
    cancelVoucher: 'Hủy phiếu',
    copy: 'Sao chép phiếu',
    dongY: 'Đồng ý',
    importExcel: 'Nhập từ Excel',
    downloadTemplate: 'Tải template',
    exportOverview: 'Xuất Excel tổng quan',
    exportDetail: 'Xuất Excel chi tiết',
    createPhieuNhap: 'Tạo phiếu nhập',
    createPhieuNhan: 'Tạo phiếu nhận',
  },
  messages: {
    loadError: 'Không tải được danh sách phiếu nhận.',
    noData: 'Chưa có phiếu nhận nào.',
    listSummary: 'Tổng số phiếu: {count}',
    createSuccess: 'Đã tạo phiếu nhận.',
    updateSuccess: 'Đã cập nhật phiếu nhận.',
    deleteSuccess: 'Đã xóa phiếu nhận.',
    needLines: 'Vui lòng thêm ít nhất một dòng hàng hóa.',
    exportSuccess: 'Đã tải file Excel.',
    importSuccess: 'Đã nhập hàng từ Excel.',
    completeSuccess: 'Đã hoàn thành phiếu nhận.',
    cancelVoucherSuccess: 'Đã hủy phiếu nhận.',
    confirmCancelVoucher: 'Hủy phiếu {name}? Hành động không thể hoàn tác.',
    confirmComplete: 'Hoàn thành nhận phiếu {name}? Sau khi hoàn thành sẽ không sửa được dòng hàng.',
    confirmCompleteWarn: 'Thao tác sẽ tạo phiếu nhập mua (NHAP_MUA) và cộng tồn kho.',
    confirmCompleteHint: 'Chọn thời gian nhập mua — mặc định theo ngày nhận trên phiếu.',
    notFound: 'Không tìm thấy phiếu nhận.',
    confirmDelete: 'Xóa phiếu nhận {name}?',
    nhanThuaWarning: 'Cảnh báo: số lượng nhận lớn hơn số lượng đặt.',
    needDatHangNcc: 'Vui lòng chọn đơn đặt hàng NCC.',
    orSupplier: 'hoặc nhập nhà cung cấp để tạo độc lập',
    needSource: 'Vui lòng chọn đơn đặt hàng hoặc nhà cung cấp.',
    checkRequiredFields: 'Vui lòng nhập đủ thông tin bắt buộc.',
    sourcePoLoaded: 'Đã nạp {count} dòng từ đơn {code}.',
    sourcePoNotFound: 'Không tìm thấy đơn đặt hàng phù hợp.',
    noLines: 'Chưa có dòng hàng hóa nào.',
    needMaLo: 'Hàng "{code}" quản lý theo hạn sử dụng — nhập số lô.',
    needHanSuDung: 'Hàng "{code}" quản lý theo hạn sử dụng — nhập hạn sử dụng.',
    needLotCount: 'Còn {count} dòng thiếu số lô / hạn sử dụng.',
  },
  detailTabs: {
    chung: 'Chung',
    generalInfo: 'Thông tin',
    chiTietHang: 'Chi tiết hàng',
    soKhop: 'So khớp nhận',
    lines: 'Danh sách nhận hàng',
  },
}
